// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"errorMessage_wrapper__1hy47","iconContainer":"errorMessage_iconContainer__h48CW"};